import "./summary.scss";

import React from "react";

interface SummaryInterface {
  title: any;
  selectSpecialist?: any;
  date?: any;
  time?: any;
}

const Summary = (props: SummaryInterface) => {
  const { title, selectSpecialist, date, time } = props;

  return (
    <div className="m-summary">
      <div className="m-summary__content">
        <div className="m-summary__header">
          <span>{title}</span>
        </div>

        <div className="m-summary__content__item">
          <i className="icon icon-stethoscope" />
          <div className="m-summary__content__item__info">
            <strong className="m-summary__content__item__info__title">
              Profesional :
            </strong>
            <p className="m-summary__content__item__info__desc">
              {selectSpecialist ? selectSpecialist : "Profesional"}
            </p>
          </div>
        </div>
        <hr className="m-summary__content__item__info__line" />
        <div className="m-summary__content__item">
          <i className="icon iconRedAmor-icon-icon-calendar" />
          <div className="m-summary__content__item__info">
            <strong className="m-summary__content__item__info__title">
              Fecha y Hora:
            </strong>
            <p className="m-summary__content__item__info__desc">
              {time ? `${date} ${time}` : "Por definir"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
